import React, { Component } from 'react';
import { withRouter, RouteComponentProps } from 'utils/withRouter';
import { LoginStore } from '../LoginStore';
import { inject, observer } from 'mobx-react';

/**
 * Named Props, not FeideCodeGetterWrapper.
 *
 * The interface used to share the class's name, so declaration merging folded the class's own
 * members — state, props, componentDidMount — into what `Component<…>` treated as its props.
 * react-router 5's types tolerated that; v7's withRouter shim does not, and the error it
 * produces ("Type '{}' is missing the following properties: state, props, context…") gives no
 * hint that a name collision is the cause.
 */
interface Props extends RouteComponentProps {
  loginStore?: LoginStore;
}

@inject('loginStore')
@observer
class FeideCodeGetterWrapper extends Component<Props> {
  public componentDidMount() {
    const code = new URLSearchParams(this.props.location.search).get('code');

    if (code === null) {
      return this.props.history.replace('/login');
    }

    // Not awaited, as before. The try/catch that used to wrap this could never run: without an
    // await it only caught a synchronous throw, and the exchange fails asynchronously. Failure is
    // handled where the state is, in LoginStore.exchangeCode, which clears the loader; App sends
    // a user who is still logged out to /login.
    void this.props.loginStore!.getUserWithToken(code);
  }

  public render() {
    return (
      <></>
    );
  }
}

export const FeideCodeGetter = withRouter(FeideCodeGetterWrapper);
